// import { getEnv } from "../shared/Services/env";
import { fetchGet, fetchPost, appUrl } from "./networkRequests";
import { createWebSocket } from "./networkWebsockets";
import { isBeta } from "./network";
// const realBeta = remote.getGlobal('env')

const WebSocket = window.WebSocket;

const prot = process.env.REACT_APP_PROTOCOL
// const prot = getEnv('PROTOCOL')

const DBG_ROOT = 'dbGallery'
async function getKeywordDictionary(userToken){
    const root_url = await appUrl()
    let res = await fetchGet(`${root_url}/${DBG_ROOT}/getKeywordDictionary`, userToken)
    res = await res.json()
    console.log('got dict', res)
    return res

}



async function getCollectionList(userToken){
  const root_url = await appUrl()
  return (await fetchGet(`${root_url}/${DBG_ROOT}/getCollectionList`, userToken)).json()
}
async function addSubcategoriesAsKeywords(userToken){
  const root_url = await appUrl()
  return (await fetchGet(`${root_url}/${DBG_ROOT}/addSubcategoriesAsKeywords`, userToken)).json()
}

async function deleteAllKeywords(userToken){
  const root_url = await appUrl()
  return (await fetchGet(`${root_url}/${DBG_ROOT}/deleteAllKeywords`, userToken)).json()
}

async function getPhotosByCollection(id, type, idsOnly, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('id', id)
  body.append('type', type)
  body.append('idsOnly', idsOnly)
  return (await fetchPost(body, `${prot}:${root_url}/${DBG_ROOT}/getPhotosByCollection`, userToken )).json()
}

async function downloadDBGalleryPhoto(id, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('id', id)
  return (await fetchPost({id},`${prot}:${root_url}/${DBG_ROOT}/downloadPhoto`, userToken)).blob()

}

async function deleteKeyword(id, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('id', id)
  return (await fetchPost(body,`${prot}:${root_url}/${DBG_ROOT}/deleteKeyword`, userToken))

}

async function getSubCollectionsByCollection(id, type, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('id', id)
  body.append('type', type)
  return (await fetchPost(body,`${prot}:${root_url}/${DBG_ROOT}/getSubCollectionsByCollection`, userToken)).json()

}

async function addKeywords(value, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('keywords', value)
  return (await fetchPost(body,`${prot}:${root_url}/${DBG_ROOT}/addKeywords`, userToken))

}

async function createVirtualSetsForReport(value, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('name', value)
  return await (await fetchPost(body,`${prot}:${root_url}/${DBG_ROOT}/createVirtualSetsForReport`, userToken)).json()

}



async function wsMovePhotosFromDBGToMS(files, user, progressCallback, endCallback){
  return new Promise(async resolve=>{
    let ws = createWebSocket();

    ws.on('open', async x => {
      let out = {
        files,
        user:user,
        dbg_move:true
      }
  
      console.log('ws channel open', out)
      ws.send(JSON.stringify(out))
    })
  
    ws.on('message', msg => {
      let reply = JSON.parse(msg)
      
      if(reply.type === 'error'){
        console.log('got an error', reply)
      }else if(reply.type === 'progress'){
        progressCallback(reply.data)
      }else if(reply.type === 'end'){
        // ws.terminate()
        endCallback()
        console.log('END OF SOCK')
      }
    
    })
    ws.on('error', err=>{
        console.log('in ws onError', err.code, err)
    })
    resolve(ws)
    // while(!ws.readyState) {
    //   await sleep(50)
    //   if(ws.readyState) 
    // }
  })
  
}

async function addToDbgQueue(queueItems, userToken){
  const root_url = await appUrl()
  let body = new FormData()
  body.append('queueItems', JSON.stringify(queueItems))
  return await (await fetchPost(body,`${prot}:${root_url}/${DBG_ROOT}/addPhotosToQueue`, userToken)).json()
}

async function getQueueStatus(userToken){
  const root_url = await appUrl()
  return await (await fetchGet(`${root_url}/${DBG_ROOT}/getQueueStatus`, userToken)).json()
}

export {
    getCollectionList,
    getPhotosByCollection,
    downloadDBGalleryPhoto,
    getKeywordDictionary,
    deleteKeyword,
    deleteAllKeywords,
    addKeywords,
    addSubcategoriesAsKeywords,
    wsMovePhotosFromDBGToMS,
    getSubCollectionsByCollection,
    createVirtualSetsForReport,
    addToDbgQueue,
    getQueueStatus
}